import Vue from 'vue'
import Store from 'store'
import verifyLabel from '../../../methods/verifyLabel'
import cookieControl from '../../../methods/cookieControl'

Vue.component('checkout-cart-buttons', {
    props: {
        labels : Object,
        dataShoppingUrl: String
    },
    computed:{
        checkoutLabels() {
            if (Store.state.main.labels) {
                return Store.state.main.labels
            }
        },
        continueShoppingUrl() {
            return this.dataShoppingUrl;
        }
    },
    methods: {
        verifyLabel(displayName) {
            if (Store.state.main.labels) {
                return verifyLabel(displayName,Store.state.main.labels)
            } else {
                return ""
            }
        },
        continueShopping() {
            const cookie = cookieControl.getItem("shopfilter")
            const url = this.continueShoppingUrl
            
            window.location.href = cookie && url 
                ? `${url}${cookie}` 
                : url 
                    ? url 
                    :'/' 
        }
    }
  });

new Vue({
    el: 'checkout-cart-buttons'
})

